import React from 'react'

const SettingShippingRuleContext = React.createContext({})

export default SettingShippingRuleContext
